module.exports = __webpack_public_path__ + "img/kuang1.0a1e2ff1.png";